import { AnyAction, Middleware } from 'redux';
import { PageState } from 'models/PageState';
import { UPDATE_CURRENT_PAGE } from 'components/Pagelayout/actions';
import { ListViewProduct } from 'models/ListViewProduct';
import { loadFromSessionStorage, PRODUCTLIST_KEY, removeFromSessionStorage } from 'utils';
import { PRODUCTLIST_PRODUCTS_UPDATE } from './actions';
import { isProductlist } from './selectors';

export const restoreProductListMiddleware: Middleware<unknown, PageState> =
  store => next => (action: AnyAction) => {
    const result = next(action);
    if (action.type === UPDATE_CURRENT_PAGE && isProductlist(action.newPage)) {
      const { pageNbr } = action.newPage;
      const previousProductList = restoreProductList(pageNbr);

      if (previousProductList) {
        store.dispatch({
          type: PRODUCTLIST_PRODUCTS_UPDATE,
          products: previousProductList
        });
      }
    }

    return result;
  };

interface SavedProducts {
  pathname: string;
  page: number;
  products: ListViewProduct[];
}

function restoreProductList(pageNbr: number): ListViewProduct[] | undefined {
  const savedProducts = loadFromSessionStorage<SavedProducts>(PRODUCTLIST_KEY);

  if (savedProducts) {
    const { pathname, page, products } = savedProducts;

    if (pathname === window.location.pathname && page === pageNbr) {
      return products;
    } else {
      removeFromSessionStorage(PRODUCTLIST_KEY);
    }
  }
  return undefined;
}
